import axios from 'axios';
const OEMBED_URL = 'https://www.wix.com/rich-content/oembed?url=';
const getAbsoluteUrl = (url)=>url.substring(0, 5).includes('http') ? url : `http://${url}`;
const buildUrl = (url)=>OEMBED_URL + encodeURIComponent(getAbsoluteUrl(url));
export const fetchUrlPreviewData = (url)=>{
    // Errors are ignored and the preview is skipped in that case.
    // Also for `wix` provider items, skip the `html` embed data and pass along
    // basic attributes for rendering a generic preview.
    return axios.get(buildUrl(url)).then((res)=>{
        var _data, _data1;
        const data = res.data || {};
        // Ignore our urls until we have time to generate full previews
        if (((_data = data) === null || _data === void 0 ? void 0 : _data.provider_url) === 'https://www.deviantart.com') {
            return {};
        }
        return ((_data1 = data) === null || _data1 === void 0 ? void 0 : _data1.provider_name) === 'wix' ? {
            title: data.title,
            description: data.description,
            thumbnail_url: data.thumbnail_url
        } : data;
    }).catch(()=>({}));
};
